/* ============================================================
   SST — Global Script
   OS Hair | Sun Skill Tech
   Cross-section behaviour. Section-specific JS lives in
   assets/sst-<section>.js. Loaded with `defer` in theme.liquid.
   Uses event delegation so it works for sections added/removed
   in the theme editor without re-binding.
   ============================================================ */
(function () {
  'use strict';

  /* ---- Mobile nav toggle ----
     Trigger:  [data-sst-nav-toggle]
     Target:   [data-sst-nav-menu] (id referenced via aria-controls)
     Toggles the `is-open` class + aria-expanded. */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-sst-nav-toggle]');
    if (!toggle) return;
    var id = toggle.getAttribute('aria-controls');
    var menu = id && document.getElementById(id);
    if (!menu) return;
    var open = menu.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', String(open));
    document.body.classList.toggle('sst-no-scroll', open);
  });

  /* ---- Accordion ----
     Wrapper:  [data-sst-accordion]
     Trigger:  [data-sst-accordion-trigger] (aria-expanded, aria-controls)
     Panel:    element with id === aria-controls
     Single-open not enforced — each toggles independently. */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-sst-accordion-trigger]');
    if (!trigger) return;
    var id = trigger.getAttribute('aria-controls');
    var panel = id && document.getElementById(id);
    if (!panel) return;
    var expanded = trigger.getAttribute('aria-expanded') === 'true';
    trigger.setAttribute('aria-expanded', String(!expanded));
    panel.hidden = expanded;
  });
})();
